module.exports = __webpack_public_path__ + "img/seedpaper-spring-break.e50cd8c9.png";